// src/utils/utils.js
export const formatPhoneNumber = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
  
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };
  
  
  export const validateContact = (method, contact) => {
    if (method === 'no-contact') {
      return true;
    }
    if (method === 'email') {
      const re = /\S+@\S+\.\S+/;
      return re.test(contact);
    }
    if (method === 'phone' || method === 'text') {
      const re = /^\d{10}$/;
      return re.test(contact);
    }
    return false;
  };
  